import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';

const HomeLayout = ({ children }) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Box sx={{
      display: 'flex',
      minHeight: '100vh',
      bgcolor: 'background.default',
    }}>
      <Box sx={{
        flexGrow: 1,
        marginLeft: isLargeScreen ? '280px' : 0,
        width: isLargeScreen ? window.innerWidth - 280 : window.innerWidth,
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      }}>
        {children}
      </Box>
    </Box>
  );
};

export default HomeLayout;